// asgains: pause CSS animations on .asgains-usps when off-screen.
// Saves battery on mobile + reduces composite/paint pressure.

(function () {
  'use strict';

  if (typeof IntersectionObserver === 'undefined') return; // graceful

  function setup() {
    const targets = document.querySelectorAll('.asgains-usps');
    if (!targets.length) return;

    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // Pause via class only when off-screen — animations run by default
        // so there's no first-paint flash before JS evaluates.
        if (entry.isIntersecting) {
          entry.target.classList.remove('asgains-out-of-view');
        } else {
          entry.target.classList.add('asgains-out-of-view');
        }
      });
    }, {
      // Start animations slightly before the section scrolls into view
      rootMargin: '100px 0px',
      threshold: 0,
    });

    targets.forEach(function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
